<template>
  <input type="submit"
         :value="$t(text)"
         class="orange-white btn width-md mb-3"
         @click="$emit('click')"
         :disabled="disabled"
  >
</template>

<script>
export default {
  props: {
    text: {
      default: '_send'
    },
    disabled: Boolean
  }
}
</script>
